import { Zap, Bell, DollarSign, MessageCircle } from "lucide-react";
import phoneMockup from "@/assets/phone-mockup.webp";

const features = [
  {
    icon: Zap,
    heading: "Fast online quotes",
    description:
      "Get a clear quote without the back and forth. Tell us what's moving, where it's going, and we'll help you price it up fast.",
  },
  {
    icon: Bell,
    heading: "Live booking confirmations",
    description:
      "Know where things stand. From booking confirmation to move-day updates, you'll always know what's happening next.",
  },
  {
    icon: DollarSign,
    heading: "Clear, upfront pricing",
    description:
      "No confusing add ons, no messy surprises. We keep pricing straightforward so you know what you're paying for before the job begins.",
  },
  {
    icon: MessageCircle,
    heading: "Easy support & updates",
    description:
      "Need to change details, confirm timing, or ask a question? We make it easy to stay in touch before, during, and after your move.",
  },
];

const MovingSimpleSection = () => (
  <section className="bg-[#f7f7f7] py-16 md:py-24">
    <div className="container">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
        {/* Left side */}
        <div className="w-full lg:w-1/2">
          <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] leading-tight mb-10">
            Moving made simple
          </h2>

          <div className="space-y-8">
            {features.map((f) => (
              <div key={f.heading} className="flex gap-4">
                <div className="shrink-0 w-10 h-10 rounded-lg bg-[#FFC300]/15 flex items-center justify-center mt-0.5">
                  <f.icon className="w-5 h-5 text-[#1a1a1a]" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#1a1a1a] mb-1">
                    {f.heading}
                  </h3>
                  <p className="text-[#1a1a1a]/75 text-sm leading-relaxed">
                    {f.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <a
            href="/#quote"
            className="inline-block mt-10 bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
          >
            Get Free Quote
          </a>
        </div>

        {/* Right side - phone mockup */}
        <div className="w-full lg:w-1/2 flex items-center justify-center">
          <img
            src={phoneMockup}
            alt="Moving job tracking app showing pickup, destination, and live status updates"
            className="w-[70%] md:w-[60%] lg:w-[85%] max-w-md h-auto"
            loading="lazy"
            width={800}
            height={1024}
          />
        </div>
      </div>
    </div>
  </section>
);

export default MovingSimpleSection;
